import { Action } from '@ngrx/store';
import { MaterialTypes } from 'app/core/store/contract-details/contract-details.interface';
import { Definitions } from 'app/core/store/definitions/definitions.interface';
import { LoadingDatesTO } from 'app/core/store/edit-relocation-detail/relocation-detail.interface';
import { CalculatedTruckLoad, DeliveryMethod, Material, OrderDetailTO, } from '../edit-florder-detail/florder-detail.interface';

export const RELOCATIONDETAIL_CLEAR = 'relocationDetail:RELOCATIONDETAIL_CLEAR';
export const RELOCATIONDETAIL_OPEN = 'relocationDetail:RELOCATIONDETAIL_OPEN';
export const RELOCATIONDETAIL_OPEN_SUCCESS = 'relocationDetail:RELOCATIONDETAIL_OPEN_SUCCESS';
export const RELOCATIONDETAIL_OPEN_FAIL = 'relocationDetail:RELOCATIONDETAIL_OPEN_FAIL';

export const RELOCATIONDETAIL_CREATE_START = 'relocationDetail:RELOCATIONDETAIL_CREATE_START'; // Start create-window
export const RELOCATIONDETAIL_CREATE_SET_DELIVERY_METHOD = 'relocationDetail:CREATE_STEP_1_SET_DELIVERY_METHOD'; // Store deliveryMethod data in store, and go to details window in edit mode
export const RELOCATIONDETAIL_EDIT_DELIVERY_METHOD = 'relocationDetail:RELOCATIONDETAIL_EDIT_DELIVERY_METHOD';
export const RELOCATIONDETAIL_CREATE_SAVE_MATERIAL_START = 'relocationDetail:RELOCATIONDETAIL_CREATE_SAVE_MATERIAL_START'; // Save material in store
export const RELOCATIONDETAIL_CREATE_SAVE_MATERIAL_SUCCESS = 'relocationDetail:RELOCATIONDETAIL_CREATE_SAVE_MATERIAL_SUCCESS'; // Save material in store
export const RELOCATIONDETAIL_CREATE_SAVE_MATERIAL_FAIL = 'relocationDetail:RELOCATIONDETAIL_CREATE_SAVE_MATERIAL_FAIL'; // Save material in store
export const RELOCATIONDETAIL_CREATE_START_EDIT_MATERIAL = 'relocationDetail:RELOCATIONDETAIL_CREATE_START_EDIT_MATERIAL'; // Start editing an existing material
export const RELOCATIONDETAIL_CREATE_DELETE_MATERIAL = 'relocationDetail:RELOCATIONDETAIL_CREATE_DELETE_MATERIAL'; // Delete material from store

export const RELOCATIONDETAIL_CREATE_SAVE_ORDER_DETAIL = 'relocationDetail:RELOCATIONDETAIL_CREATE_SAVE_ORDER_DETAIL'; // Save relocation detail data in store
export const RELOCATIONDETAIL_CREATE_EDIT_ORDER_DETAIL = 'relocationDetail:RELOCATIONDETAIL_CREATE_EDIT_ORDER_DETAIL'; // Start adding a new material (used when editing details again)
export const RELOCATIONDETAIL_CREATE_SAVE_PLANNING = 'relocationDetail:RELOCATIONDETAIL_CREATE_SAVE_PLANNING';
export const RELOCATIONDETAIL_CREATE_EDIT_ORDER_PLANNING = 'relocationDetail:RELOCATIONDETAIL_CREATE_EDIT_ORDER_PLANNING';

export const RELOCATIONDETAIL_CREATE_SUBMIT = 'relocationDetail:RELOCATIONDETAIL_CREATE_SUBMIT'; // Submit 'create relocation' data to middleware
export const RELOCATIONDETAIL_CREATE_SUBMIT_FAIL = 'relocationDetail:RELOCATIONDETAIL_CREATE_SUBMIT_FAIL'; // Submit failed
export const RELOCATIONDETAIL_CREATE_SUBMIT_SUCCESS = 'relocationDetail:RELOCATIONDETAIL_CREATE_SUBMIT_SUCCESS'; // Submit successful

export const RELOCATIONDETAIL_COPY_RELOCATION = 'relocationDetail:RELOCATIONDETAIL_COPY_RELOCATION';
export const RELOCATIONDETAIL_COPY_OPEN_RELOCATION_SUCCESS = 'relocationDetail:RELOCATIONDETAIL_COPY_OPEN_RELOCATION_SUCCESS';

export const RELOCATIONDETAIL_BACK_TO_CREATE_CONFIRM = 'relocationDetail:RELOCATIONDETAIL_BACK_TO_CREATE_CONFIRM';

export const RELOCATIONDETAIL_CREATE_FROM_TEMPLATE = 'relocationDetail:RELOCATIONDETAIL_CREATE_FROM_TEMPLATE';

export const RELOCATIONDETAIL_REQUEST_LOADING_DATES = 'relocationDetail:RELOCATIONDETAIL_REQUEST_LOADING_DATES';
export const RELOCATIONDETAIL_REQUEST_LOADING_DATES_SUCCESS = 'relocationDetail:RELOCATIONDETAIL_REQUEST_LOADING_DATES_SUCCESS';
export const RELOCATIONDETAIL_REQUEST_LOADING_DATES_FAIL = 'relocationDetail:RELOCATIONDETAIL_REQUEST_LOADING_DATES_FAIL';

export const RELOCATIONDETAIL_GET_MATERIALS = 'relocationDetail:RELOCATIONDETAIL_GET_MATERIALS';
export const RELOCATIONDETAIL_GET_MATERIALS_WITH_FROM_TO = 'relocationDetail:RELOCATIONDETAIL_GET_MATERIALS_WITH_FROM_TO';
export const RELOCATIONDETAIL_GET_MATERIALS_SUCCESS = 'relocationDetail:RELOCATIONDETAIL_GET_MATERIALS_SUCCESS';
export const RELOCATIONDETAIL_GET_MATERIALS_FAIL = 'relocationDetail:RELOCATIONDETAIL_GET_MATERIALS_FAIL';

export class RelocationDetailClearAction implements Action {
  readonly type = RELOCATIONDETAIL_CLEAR;
}

export class RelocationDetailOpenAction implements Action {
  readonly type = RELOCATIONDETAIL_OPEN;
  logPayload = true;

  ui = {
    id: RELOCATIONDETAIL_OPEN,
    busy: true,
  };

  constructor(readonly payload: { etmOrderNumber: string; salesOrderNumber: string }) {}
}

export class RelocationDetailOpenSuccessAction implements Action {
  readonly type = RELOCATIONDETAIL_OPEN_SUCCESS;

  ui = {
    id: RELOCATIONDETAIL_OPEN,
    busy: false,
  };

  constructor(readonly payload: OrderDetailTO) {}
}

export class RelocationDetailOpenFailAction implements Action {
  readonly type = RELOCATIONDETAIL_OPEN_FAIL;
  logPayload = true;

  ui = {
    id: RELOCATIONDETAIL_OPEN,
    busy: false,
  };

  constructor(readonly payload: any) {}
}

export class RelocationDetailCreateStartAction implements Action {
  readonly type = RELOCATIONDETAIL_CREATE_START;
  logPayload = true;

  constructor(readonly payload: { date: string }) {}
}

export class RelocationDetailCreateSetDeliveryMethodAction implements Action {
  readonly type = RELOCATIONDETAIL_CREATE_SET_DELIVERY_METHOD;

  constructor(readonly payload: { deliveryMethod: DeliveryMethod }) {}
}

export class RelocationDetailEditDeliveryMethodAction implements Action {
  readonly type = RELOCATIONDETAIL_EDIT_DELIVERY_METHOD;
}

export class RelocationDetailCreateSaveMaterialStartAction implements Action {
  readonly type = RELOCATIONDETAIL_CREATE_SAVE_MATERIAL_START;

  constructor(readonly payload: { material: any; gotoPlanning?: boolean; showPopup?: boolean }) {}
}

export class RelocationDetailCreateSaveMaterialSuccessAction implements Action {
  readonly type = RELOCATIONDETAIL_CREATE_SAVE_MATERIAL_SUCCESS;

  constructor(readonly payload: { calculation: CalculatedTruckLoad; material: Material }) {}
}

export class RelocationDetailCreateSaveMaterialFailAction implements Action {
  readonly type = RELOCATIONDETAIL_CREATE_SAVE_MATERIAL_FAIL;
  logPayload = true;

  constructor(readonly payload: any) {}
}

export class RelocationDetailCreateStartEditMaterialAction implements Action {
  readonly type = RELOCATIONDETAIL_CREATE_START_EDIT_MATERIAL;

  constructor(readonly payload: Material) {}
}

export class RelocationDetailCreateRemoveMaterialAction implements Action {
  readonly type = RELOCATIONDETAIL_CREATE_DELETE_MATERIAL;

  constructor(readonly payload: any) {}
}

export class RelocationDetailSaveOrderDetailAction implements Action {
  readonly type = RELOCATIONDETAIL_CREATE_SAVE_ORDER_DETAIL;
}

export class RelocationDetailCreateEditOrderDetailAction implements Action {
  readonly type = RELOCATIONDETAIL_CREATE_EDIT_ORDER_DETAIL;
}

export class RelocationDetailSavePlanningAction implements Action {
  readonly type = RELOCATIONDETAIL_CREATE_SAVE_PLANNING;

  constructor(readonly payload: any) {}
}

export class RelocationDetailCreateEditOrderPlanningAction implements Action {
  readonly type = RELOCATIONDETAIL_CREATE_EDIT_ORDER_PLANNING;
}

export class RelocationDetailCreateSubmitAction implements Action {
  readonly type = RELOCATIONDETAIL_CREATE_SUBMIT;
}

export class RelocationDetailCreateSubmitFailAction implements Action {
  readonly type = RELOCATIONDETAIL_CREATE_SUBMIT_FAIL;

  constructor(readonly payload?: any) {}
}

export class RelocationDetailCreateSubmitSuccessAction implements Action {
  readonly type = RELOCATIONDETAIL_CREATE_SUBMIT_SUCCESS;
  logPayload = true;

  constructor(readonly payload?: any) {}
}

export class RelocationDetailCopyOrderAction implements Action {
  readonly type = RELOCATIONDETAIL_COPY_RELOCATION;
  logPayload = true;

  constructor(readonly payload: { etmOrderNumber: string }) {} // id
}

export class RelocationDetailCopyOpenSuccessAction implements Action {
  readonly type = RELOCATIONDETAIL_COPY_OPEN_RELOCATION_SUCCESS;

  constructor(readonly payload: { definitions: Definitions; relocationDetail: any }) {}
}

export class RelocationDetailBackToCreateConfirmAction implements Action {
  readonly type = RELOCATIONDETAIL_BACK_TO_CREATE_CONFIRM;
}

export class RelocationDetailCreateFromTemplateAction implements Action {
  readonly type = RELOCATIONDETAIL_CREATE_FROM_TEMPLATE;

  constructor(readonly payload: { template: { data: OrderDetailTO; id: number; name: string }; date?: string }) {}
}

export class RelocationDetailRequestLoadingDatesAction implements Action {
  readonly type = RELOCATIONDETAIL_REQUEST_LOADING_DATES;
  logPayload = true;

  ui = {
    id: RELOCATIONDETAIL_REQUEST_LOADING_DATES,
    busy: true,
  };

  constructor(readonly payload: { fromId: string; toId: string }) {} // Which action to trigger when success
}

export class RelocationDetailRequestLoadingDatesSuccessAction implements Action {
  readonly type = RELOCATIONDETAIL_REQUEST_LOADING_DATES_SUCCESS;
  logPayload = true;

  ui = {
    id: RELOCATIONDETAIL_REQUEST_LOADING_DATES,
    busy: false,
  };

  constructor(readonly payload: LoadingDatesTO) {}
}

export class RelocationDetailRequestLoadingDatesFailAction implements Action {
  readonly type = RELOCATIONDETAIL_REQUEST_LOADING_DATES_FAIL;
  logPayload = true;

  ui = {
    id: RELOCATIONDETAIL_REQUEST_LOADING_DATES,
    busy: false,
  };

  constructor(readonly payload: any) {}
}

export class RelocationDetailGetMaterialsAction implements Action {
  readonly type = RELOCATIONDETAIL_GET_MATERIALS;
  logPayload = true;

  ui = {
    id: RELOCATIONDETAIL_GET_MATERIALS,
    busy: true,
  };

  constructor(readonly payload: { depotId: string }) {} // Which action to trigger when success
}

export class RelocationDetailGetMaterialsWithFromToAction implements Action {
  readonly type = RELOCATIONDETAIL_GET_MATERIALS_WITH_FROM_TO;
  logPayload = true;

  ui = {
    id: RELOCATIONDETAIL_GET_MATERIALS,
    busy: true,
  };

  constructor(readonly payload: { fromId: string; toId }) {} // Which action to trigger when success
}

export class RelocationDetailGetMaterialsSuccessAction implements Action {
  readonly type = RELOCATIONDETAIL_GET_MATERIALS_SUCCESS;

  ui = {
    id: RELOCATIONDETAIL_GET_MATERIALS,
    busy: false,
  };

  constructor(readonly payload: MaterialTypes) {}
}

export class RelocationDetailGetMaterialsFailAction implements Action {
  readonly type = RELOCATIONDETAIL_GET_MATERIALS_FAIL;
  logPayload = true;

  ui = {
    id: RELOCATIONDETAIL_GET_MATERIALS,
    busy: false,
  };

  constructor(readonly payload: any) {}
}

export type Actions =
  | RelocationDetailClearAction
  | RelocationDetailOpenAction
  | RelocationDetailOpenFailAction
  | RelocationDetailOpenSuccessAction
  | RelocationDetailCreateStartAction
  | RelocationDetailCreateSetDeliveryMethodAction
  | RelocationDetailEditDeliveryMethodAction
  | RelocationDetailCreateSaveMaterialStartAction
  | RelocationDetailCreateSaveMaterialSuccessAction
  | RelocationDetailCreateSaveMaterialFailAction
  | RelocationDetailCreateStartEditMaterialAction
  | RelocationDetailCreateRemoveMaterialAction
  | RelocationDetailSaveOrderDetailAction
  | RelocationDetailCreateEditOrderDetailAction
  | RelocationDetailSavePlanningAction
  | RelocationDetailCreateEditOrderPlanningAction
  | RelocationDetailCreateSubmitAction
  | RelocationDetailCreateSubmitFailAction
  | RelocationDetailCreateSubmitSuccessAction
  | RelocationDetailCopyOrderAction
  | RelocationDetailCopyOpenSuccessAction
  | RelocationDetailBackToCreateConfirmAction
  | RelocationDetailCreateFromTemplateAction
  | RelocationDetailRequestLoadingDatesAction
  | RelocationDetailRequestLoadingDatesSuccessAction
  | RelocationDetailRequestLoadingDatesFailAction
  | RelocationDetailGetMaterialsAction
  | RelocationDetailGetMaterialsWithFromToAction
  | RelocationDetailGetMaterialsSuccessAction
  | RelocationDetailGetMaterialsFailAction;
